import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Badge,
  Switch,
  FormControlLabel,
  Divider,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Straighten as UnitIcon,
  Info as InfoIcon,
  Refresh as RefreshIcon,
  Visibility as ViewIcon,
  LocalOffer as TagIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Calculate as CalculateIcon,
  SwapHoriz as ConvertIcon,
  Inventory as ProductIcon,
  Scale as WeightIcon,
  Architecture as MeasureIcon,
} from "@mui/icons-material";

const UnitMaster = () => {
  const [unitData, setUnitData] = useState([
    { 
      id: 1, 
      unitCode: "UNT001",
      unitName: "Piece", 
      unitSymbol: "Pcs",
      unitType: "Count",
      baseUnit: null,
      conversionFactor: 1,
      description: "Individual items or pieces",
      productCount: 85,
      status: "Active",
      isBaseUnit: true,
      allowDecimal: false,
      displayOrder: 1,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 2, 
      unitCode: "UNT002",
      unitName: "Kilogram", 
      unitSymbol: "Kg",
      unitType: "Weight",
      baseUnit: null,
      conversionFactor: 1,
      description: "Metric unit of mass",
      productCount: 42,
      status: "Active",
      isBaseUnit: true,
      allowDecimal: true,
      displayOrder: 2,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 3, 
      unitCode: "UNT003",
      unitName: "Gram", 
      unitSymbol: "Gm",
      unitType: "Weight",
      baseUnit: "Kilogram",
      conversionFactor: 0.001,
      description: "1000 grams = 1 kilogram",
      productCount: 28,
      status: "Active",
      isBaseUnit: false,
      allowDecimal: true,
      displayOrder: 3,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 4, 
      unitCode: "UNT004",
      unitName: "Liter", 
      unitSymbol: "Ltr",
      unitType: "Volume",
      baseUnit: null,
      conversionFactor: 1,
      description: "Metric unit of volume",
      productCount: 35,
      status: "Active",
      isBaseUnit: true,
      allowDecimal: true,
      displayOrder: 4,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 5, 
      unitCode: "UNT005",
      unitName: "Milliliter", 
      unitSymbol: "Ml",
      unitType: "Volume",
      baseUnit: "Liter",
      conversionFactor: 0.001,
      description: "1000 milliliters = 1 liter",
      productCount: 18,
      status: "Active",
      isBaseUnit: false,
      allowDecimal: true,
      displayOrder: 5,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 6, 
      unitCode: "UNT006",
      unitName: "Meter", 
      unitSymbol: "Mtr",
      unitType: "Length",
      baseUnit: null,
      conversionFactor: 1,
      description: "Metric unit of length",
      productCount: 22,
      status: "Active",
      isBaseUnit: true,
      allowDecimal: true,
      displayOrder: 6,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 7, 
      unitCode: "UNT007",
      unitName: "Centimeter", 
      unitSymbol: "Cm",
      unitType: "Length",
      baseUnit: "Meter",
      conversionFactor: 0.01,
      description: "100 centimeters = 1 meter",
      productCount: 15,
      status: "Active",
      isBaseUnit: false,
      allowDecimal: true,
      displayOrder: 7,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 8, 
      unitCode: "UNT008",
      unitName: "Box", 
      unitSymbol: "Box",
      unitType: "Package",
      baseUnit: null,
      conversionFactor: 1,
      description: "Standard packaging box",
      productCount: 45,
      status: "Active",
      isBaseUnit: true,
      allowDecimal: false,
      displayOrder: 8,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 9, 
      unitCode: "UNT009",
      unitName: "Dozen", 
      unitSymbol: "Dzn",
      unitType: "Count",
      baseUnit: "Piece",
      conversionFactor: 12,
      description: "12 pieces = 1 dozen",
      productCount: 31,
      status: "Active",
      isBaseUnit: false,
      allowDecimal: false,
      displayOrder: 9,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 10, 
      unitCode: "UNT010",
      unitName: "Set", 
      unitSymbol: "Set",
      unitType: "Package",
      baseUnit: null,
      conversionFactor: 1,
      description: "Collection of items sold together",
      productCount: 38,
      status: "Active",
      isBaseUnit: true,
      allowDecimal: false,
      displayOrder: 10,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 11, 
      unitCode: "UNT011",
      unitName: "Carton", 
      unitSymbol: "Ctn",
      unitType: "Package",
      baseUnit: null,
      conversionFactor: 1,
      description: "Large packaging carton",
      productCount: 0,
      status: "Inactive",
      isBaseUnit: true,
      allowDecimal: false,
      displayOrder: 11,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
    { 
      id: 12, 
      unitCode: "UNT012",
      unitName: "Square Meter", 
      unitSymbol: "Sqm",
      unitType: "Area",
      baseUnit: null,
      conversionFactor: 1,
      description: "Unit of area measurement",
      productCount: 12,
      status: "Active",
      isBaseUnit: true,
      allowDecimal: true,
      displayOrder: 12,
      createdDate: "2024-01-05",
      updatedDate: "2024-01-05"
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [baseUnitFilter, setBaseUnitFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editingUnit, setEditingUnit] = useState(null);
  const [viewingUnit, setViewingUnit] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newUnit, setNewUnit] = useState({
    unitCode: "",
    unitName: "",
    unitSymbol: "",
    unitType: "Count",
    baseUnit: "",
    conversionFactor: 1,
    description: "",
    status: "Active",
    isBaseUnit: true,
    allowDecimal: false,
    displayOrder: 1,
  });

  // Get unique unit types for filter
  const unitTypes = [...new Set(unitData.map(u => u.unitType))];
  
  // Get base units for dropdown and filter
  const baseUnits = unitData.filter(u => u.isBaseUnit);

  // Helper functions
  const getFilteredUnits = () => {
    return unitData.filter((unit) => {
      const matchesSearch = Object.values(unit).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
      const matchesStatus = statusFilter === "all" || unit.status === statusFilter;
      const matchesType = typeFilter === "all" || unit.unitType === typeFilter;
      const matchesBaseUnit = baseUnitFilter === "all" || 
        (baseUnitFilter === "base" && unit.isBaseUnit) ||
        (baseUnitFilter === "derived" && !unit.isBaseUnit);
      return matchesSearch && matchesStatus && matchesType && matchesBaseUnit;
    });
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Active':
        return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
      case 'Inactive':
        return { backgroundColor: '#ffebee', color: '#d32f2f' };
      default:
        return { backgroundColor: '#f5f5f5', color: '#666' };
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Count': return 'primary';
      case 'Weight': return 'secondary';
      case 'Volume': return 'info';
      case 'Length': return 'success';
      case 'Area': return 'warning';
      case 'Package': return 'error';
      default: return 'default';
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newUnit.unitName.trim()) newErrors.unitName = 'Unit name is required';
    if (!newUnit.unitSymbol.trim()) newErrors.unitSymbol = 'Unit symbol is required';
    if (!newUnit.unitType.trim()) newErrors.unitType = 'Unit type is required';
    if (!newUnit.isBaseUnit && !newUnit.baseUnit) {
      newErrors.baseUnit = 'Base unit is required for derived units';
    }
    if (!newUnit.isBaseUnit && (!newUnit.conversionFactor || newUnit.conversionFactor <= 0)) {
      newErrors.conversionFactor = 'Conversion factor must be greater than 0';
    }
    if (!newUnit.displayOrder || newUnit.displayOrder <= 0) {
      newErrors.displayOrder = 'Display order must be greater than 0';
    }
    return newErrors;
  };

  // Handlers
  const handleEdit = (unit) => {
    setEditingUnit(unit);
    setNewUnit({ ...unit });
    setOpenModal(true);
  };

  const handleView = (unit) => {
    setViewingUnit(unit);
    setOpenViewModal(true);
  };

  const handleDelete = (id) => {
    const unitToDelete = unitData.find(u => u.id === id);
    
    // Check if unit has products
    if (unitToDelete.productCount > 0) {
      alert(`Cannot delete unit with ${unitToDelete.productCount} products. Please reassign or delete products first.`);
      return;
    }

    // Check if this is a base unit with derived units
    const hasDerivedUnits = unitData.some(u => u.baseUnit === unitToDelete.unitName);
    if (hasDerivedUnits) {
      alert("Cannot delete base unit with derived units. Please delete or reassign derived units first.");
      return;
    }

    if (window.confirm("Are you sure you want to delete this unit?")) {
      setUnitData(unitData.filter((unit) => unit.id !== id));
      setSuccessMessage("Unit deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Search and filter handlers
  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredUnits().length} units.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setTypeFilter("all");
    setBaseUnitFilter("all");
    setPage(0);
    setErrors({});
    setSuccessMessage("");
  };

  const handleOpenModal = () => {
    setEditingUnit(null);
    setNewUnit({
      unitCode: "",
      unitName: "",
      unitSymbol: "",
      unitType: "Count",
      baseUnit: "",
      conversionFactor: 1,
      description: "",
      status: "Active",
      isBaseUnit: true,
      allowDecimal: false,
      displayOrder: 1,
    });
    setErrors({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingUnit(null);
    setErrors({});
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setViewingUnit(null);
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    
    setNewUnit({ 
      ...newUnit, 
      [name]: newValue,
      // If switching to base unit, reset base unit and conversion factor
      ...(name === 'isBaseUnit' && checked ? { baseUnit: '', conversionFactor: 1 } : {})
    });
    
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleAddUnit = async () => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsLoading(true);
    try {
      if (editingUnit) {
        // Update existing unit
        setUnitData(unitData.map(unit => 
          unit.id === editingUnit.id 
            ? { 
                ...unit, 
                ...newUnit,
                updatedDate: new Date().toISOString().split('T')[0]
              }
            : unit
        ));
        setSuccessMessage("Unit updated successfully!");
      } else {
        // Add new unit
        const newId = unitData.length > 0 ? Math.max(...unitData.map(u => u.id)) + 1 : 1;
        const unitCode = `UNT${String(newId).padStart(3, '0')}`;
        setUnitData([...unitData, { 
          id: newId, 
          ...newUnit,
          unitCode: newUnit.unitCode || unitCode,
          productCount: 0,
          createdDate: new Date().toISOString().split('T')[0],
          updatedDate: new Date().toISOString().split('T')[0]
        }]);
        setSuccessMessage("Unit added successfully!");
      }
      handleCloseModal();
    } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    } finally {
      setIsLoading(false);
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const filteredUnits = getFilteredUnits();

  // Calculate statistics
  const totalUnits = unitData.length;
  const activeUnits = unitData.filter(u => u.status === "Active").length;
  const baseUnitsCount = unitData.filter(u => u.isBaseUnit).length;
  const derivedUnits = unitData.filter(u => !u.isBaseUnit).length;
  const totalProducts = unitData.reduce((sum, unit) => sum + unit.productCount, 0);

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Badge badgeContent={totalUnits} color="primary">
            <UnitIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          </Badge>
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Unit Master Management
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage units of measurement for products • {filteredUnits.length} units found
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            fontWeight: 600,
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          Add New Unit
        </Button>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Statistics Cards */}
      {/* <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <UnitIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="primary">
                {totalUnits}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Units
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <CheckCircleIcon sx={{ fontSize: 40, color: 'success.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="success.main">
                {activeUnits}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Active Units
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <MeasureIcon sx={{ fontSize: 40, color: 'info.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="info.main">
                {baseUnitsCount}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Base Units
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <ConvertIcon sx={{ fontSize: 40, color: 'warning.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="warning.main">
                {derivedUnits}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Derived Units
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <ProductIcon sx={{ fontSize: 40, color: 'secondary.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="secondary.main">
                {totalProducts}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Products
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Search Units..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Filter by Type"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Types</option>
              {unitTypes.map((type) => (
                <option key={type} value={type}>{type}</option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Unit Category"
              value={baseUnitFilter}
              onChange={(e) => setBaseUnitFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Units</option>
              <option value="base">Base Units</option>
              <option value="derived">Derived Units</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Status"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                onClick={handleSearch}
                startIcon={<SearchIcon />}
                sx={{ flex: 1 }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                onClick={handleReset}
                startIcon={<RefreshIcon />}
                sx={{ flex: 1 }}
              >
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Unit Code</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Unit Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Symbol</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Base Unit</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Conversion</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Products</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Decimal</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredUnits.length > 0 ? (
                filteredUnits
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((unit, index) => (
                    <TableRow 
                      key={unit.id} 
                      sx={{ 
                        '&:hover': { backgroundColor: '#f5f5f5' },
                        transition: 'background-color 0.2s'
                      }}
                    >
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <TagIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                          {unit.unitCode}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="600">
                          {unit.unitName}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={unit.unitSymbol} 
                          size="small"
                          sx={{ 
                            fontWeight: 600,
                            backgroundColor: 'primary.light',
                            color: 'primary.dark'
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={unit.unitType} 
                          size="small" 
                          color={getTypeColor(unit.unitType)}
                          sx={{ fontWeight: 500 }}
                        />
                      </TableCell>
                      <TableCell>
                        {unit.isBaseUnit ? (
                          <Chip 
                            label="Base Unit" 
                            size="small"
                            icon={<MeasureIcon />}
                            color="info"
                            variant="outlined"
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            {unit.baseUnit}
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        {unit.isBaseUnit ? (
                          <Typography variant="body2" color="text.secondary">-</Typography>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <CalculateIcon sx={{ fontSize: 16, color: 'warning.main' }} />
                            <Typography variant="body2" fontWeight="600">
                              {unit.conversionFactor}
                            </Typography>
                          </Box>
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography 
                          sx={{ 
                            fontWeight: 600,
                            color: unit.productCount === 0 ? 'text.secondary' : 'primary.main'
                          }}
                        >
                          {unit.productCount}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {unit.allowDecimal ? (
                          <CheckCircleIcon sx={{ color: 'success.main', fontSize: 20 }} />
                        ) : (
                          <CancelIcon sx={{ color: 'error.main', fontSize: 20 }} />
                        )}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={unit.status}
                          size="small"
                          sx={{
                            ...getStatusStyle(unit.status),
                            fontWeight: 600,
                            fontSize: '0.75rem'
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              onClick={() => handleView(unit)}
                              sx={{
                                color: 'info.main',
                                '&:hover': {
                                  backgroundColor: 'info.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Unit">
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(unit)}
                              sx={{
                                color: 'warning.main',
                                '&:hover': {
                                  backgroundColor: 'warning.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Unit">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(unit.id)}
                              sx={{
                                color: 'error.main',
                                '&:hover': {
                                  backgroundColor: 'error.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={11} align="center" sx={{ py: 4 }}>
                    <UnitIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body1" color="text.secondary">
                      No units found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Try adjusting your search criteria or add a new unit.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredUnits.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </Paper>

      {/* Add/Edit Unit Modal */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <UnitIcon />
            {editingUnit ? 'Edit Unit' : 'Add New Unit'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Unit Code"
                name="unitCode"
                value={newUnit.unitCode}
                onChange={handleInputChange}
                helperText="Auto-generated if left empty"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <TagIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Unit Name"
                name="unitName"
                value={newUnit.unitName}
                onChange={handleInputChange}
                error={!!errors.unitName}
                helperText={errors.unitName}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Unit Symbol/Abbreviation"
                name="unitSymbol"
                value={newUnit.unitSymbol}
                onChange={handleInputChange}
                error={!!errors.unitSymbol}
                helperText={errors.unitSymbol}
                placeholder="e.g., Kg, Ltr, Pcs"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.unitType}>
                <InputLabel>Unit Type *</InputLabel>
                <Select
                  name="unitType"
                  value={newUnit.unitType}
                  onChange={handleInputChange}
                  label="Unit Type *"
                >
                  <MenuItem value="Count">Count</MenuItem>
                  <MenuItem value="Weight">Weight</MenuItem>
                  <MenuItem value="Volume">Volume</MenuItem>
                  <MenuItem value="Length">Length</MenuItem>
                  <MenuItem value="Area">Area</MenuItem>
                  <MenuItem value="Package">Package</MenuItem>
                </Select>
                {errors.unitType && <Typography variant="caption" color="error">{errors.unitType}</Typography>}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newUnit.isBaseUnit}
                    onChange={handleInputChange}
                    name="isBaseUnit"
                    color="primary"
                  />
                }
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <MeasureIcon sx={{ fontSize: 18 }} />
                    This is a Base Unit (not derived from another unit)
                  </Box>
                }
              />
            </Grid>
            {!newUnit.isBaseUnit && (
              <>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth error={!!errors.baseUnit}>
                    <InputLabel>Base Unit *</InputLabel>
                    <Select
                      name="baseUnit"
                      value={newUnit.baseUnit}
                      onChange={handleInputChange}
                      label="Base Unit *"
                      disabled={newUnit.isBaseUnit}
                    >
                      <MenuItem value="">Select Base Unit</MenuItem>
                      {baseUnits
                        .filter(bu => bu.unitType === newUnit.unitType)
                        .map((bu) => (
                          <MenuItem key={bu.id} value={bu.unitName}>
                            {bu.unitName} ({bu.unitSymbol})
                          </MenuItem>
                        ))}
                    </Select>
                    {errors.baseUnit && (
                      <Typography variant="caption" color="error" sx={{ ml: 2 }}>
                        {errors.baseUnit}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Conversion Factor"
                    name="conversionFactor"
                    type="number"
                    value={newUnit.conversionFactor}
                    onChange={handleInputChange}
                    error={!!errors.conversionFactor}
                    helperText={errors.conversionFactor || "e.g., 1000 (1000 units = 1 base unit)"}
                    disabled={newUnit.isBaseUnit}
                    inputProps={{ step: 0.001 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CalculateIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Display Order"
                name="displayOrder"
                type="number"
                value={newUnit.displayOrder}
                onChange={handleInputChange}
                error={!!errors.displayOrder}
                helperText={errors.displayOrder}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={newUnit.status}
                  onChange={handleInputChange}
                  label="Status"
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newUnit.allowDecimal}
                    onChange={handleInputChange}
                    name="allowDecimal"
                    color="primary"
                  />
                }
                label="Allow Decimal Values"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={newUnit.description}
                onChange={handleInputChange}
                multiline
                rows={3}
                placeholder="Enter unit description..."
              />
            </Grid>
          </Grid>
          {errors.general && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errors.general}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddUnit}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : <AddIcon />}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {isLoading ? 'Processing...' : (editingUnit ? 'Update Unit' : 'Add Unit')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Unit Modal */}
      <Dialog open={openViewModal} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon />
            Unit Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          {viewingUnit && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Avatar 
                    sx={{ 
                      width: 80, 
                      height: 80, 
                      margin: '0 auto',
                      backgroundColor: 'primary.main',
                    }}
                  >
                    <UnitIcon sx={{ fontSize: 40 }} />
                  </Avatar>
                  <Typography variant="h5" sx={{ mt: 2, fontWeight: 'bold' }}>
                    {viewingUnit.unitName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {viewingUnit.unitCode}
                  </Typography>
                  <Chip 
                    label={viewingUnit.unitSymbol} 
                    sx={{ 
                      mt: 1,
                      fontWeight: 600,
                      fontSize: '0.9rem',
                      backgroundColor: 'primary.light',
                      color: 'primary.dark'
                    }}
                  />
                </Box>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Unit Type</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip 
                      label={viewingUnit.unitType} 
                      color={getTypeColor(viewingUnit.unitType)}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Category</Typography>
                  <Box sx={{ mt: 1 }}>
                    {viewingUnit.isBaseUnit ? (
                      <Chip 
                        label="Base Unit" 
                        icon={<MeasureIcon />}
                        color="info"
                      />
                    ) : (
                      <Chip 
                        label="Derived Unit" 
                        icon={<ConvertIcon />}
                        color="warning"
                      />
                    )}
                  </Box>
                </Paper>
              </Grid>
              
              {!viewingUnit.isBaseUnit && (
                <>
                  <Grid item xs={12} sm={6}>
                    <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                      <Typography variant="caption" color="text.secondary">Base Unit</Typography>
                      <Typography variant="body1" fontWeight="bold">
                        {viewingUnit.baseUnit}
                      </Typography>
                    </Paper>
                  </Grid>
                  
                  <Grid item xs={12} sm={6}>
                    <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                      <Typography variant="caption" color="text.secondary">Conversion Factor</Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <CalculateIcon sx={{ color: 'warning.main' }} />
                        <Typography variant="body1" fontWeight="bold">
                          {viewingUnit.conversionFactor}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </>
              )}
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Products Using This Unit</Typography>
                  <Typography variant="body1" fontWeight="bold" color="primary">
                    {viewingUnit.productCount} Products
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Allow Decimal Values</Typography>
                  <Box sx={{ mt: 1 }}>
                    {viewingUnit.allowDecimal ? (
                      <Chip icon={<CheckCircleIcon />} label="Yes" color="success" />
                    ) : (
                      <Chip icon={<CancelIcon />} label="No" color="error" />
                    )}
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Display Order</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingUnit.displayOrder}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Status</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip
                      label={viewingUnit.status}
                      sx={{
                        ...getStatusStyle(viewingUnit.status),
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Description</Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {viewingUnit.description || 'No description available'}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Created Date</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingUnit.createdDate}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Last Updated</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingUnit.updatedDate}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseViewModal}>Close</Button>
          {viewingUnit && (
            <Button
              variant="contained"
              onClick={() => {
                handleCloseViewModal();
                handleEdit(viewingUnit);
              }}
              startIcon={<EditIcon />}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }}
            >
              Edit Unit
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default UnitMaster;

